<template>
  <reactive-base
    app="oncology"
    testurl="https://search-springerhealthcaredev-diuqs74ej2l5d4hnevbtfhloui.eu-west-2.es.amazonaws.com"
    url="https://snproject8a7579dd.ew.r.appspot.com/"
  >
    <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
      <v-dialog name="offramp" ref="offramp" persistent />
      <div class="searchbar flex">
        <DataSearch
          componentId="SearchText"
          iconPosition="right"
          :dataField="['chapterTitle','chapterExperts.creator','text','chapterAbstract','chapterFilterTerms.filterTerm','bookTitle','bookSubjectGroup.BookSubject' ]"
          :queryFormat="and"
				  debounce=1500
				  :highlight=false
				  className="data-search"
          :showClear="true"
          filterLabel="Searching for"
          :autosuggest=true
          placeholder="Search for chapters"
				  :react="{ and: ['Orderable', 'Subjects', 'Filters','Authors','PublishedYear'] }"
				  />
      </div>
      <button class="btn btn-primary" id="menu-toggle" style="margin-right:10px">Toggle Filters</button>

      <div class="filter-controls">
        <button
          class="toggle"
          @click="switchContainer"
        >{{ showBooks ? 'Show Filters' : 'Hide Filters' }}</button>
        <SelectedFilters class="myfilters" :showClearAll="true" clearAllLabel="Clear filters" />
      </div>
    </nav>

    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <div class="bg-light border-right" id="sidebar-wrapper" :class="{ hide: showBooks }">
        <div class="filters-container">
          <range-slider
            componentId="PublishedYear"
            data-field="bookPublishedYear"
            title="Published Year"
            :range="{
						start: 2010,
						end: 2018
					}"
            class="filter"
            :react="{ and: ['SearchText', 'Subjects', 'Authors','Filters'] }"
          />

          <multi-list
            componentId="Orderable"
            data-field="XXXbookFlaggedForOrderable.keyword"
            class="filter"
            title="Available to order"
            :showSearch="false"
            :react="{ and: ['SearchText', 'Filters', 'Authors','PublishedYear'] }"
          />
          <multi-list
            componentId="Subjects"
            data-field="bookSubjectGroup.BookSubject.keyword"
            class="filter filternoscroll"
            sortBy="asc"
            title="Categories"
            :showFilter="true"
            selectAllLabel="All categories"
            :react="{ and: ['SearchText', 'Filters', 'Authors','PublishedYear'] }"
          />
          <multi-list
            componentId="Filters"
            data-field="chapterFilterTerms.filterTerm.keyword"
            class="filter filternoscroll"
            title="Topics"
            sortBy="asc"
            selectAllLabel="All filters"
            :react="{ and: ['SearchText', 'Subjects', 'Authors','PublishedYear'] }"
          />
          <multi-list
            componentId="Authors"
            data-field="chapterExperts.creator.keyword"
            class="filter filternoscroll"
            title="Authors"
            sortBy="asc"
            selectAllLabel="All authors"
            :react="{ and: ['SearchText', 'Subjects', 'Filters','PublishedYear'] }"
          />

          <div class="c">
            <a
              class="menuoption"
              target="_blank"
              href="https://springerhealthcare.com/privacy-cookies/"
            >Privacy and Cookies</a>
          </div>
          <div class="c">
            <img
              src="https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_1x.png"
              srcset="https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_1x.png 1x, https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_2x.png 2x, https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_3x.png 3x"
              alt="Springer Healthcare"
              class="SHClogoImage"
            />
          </div>
        </div>
      </div>
      <!-- /#sidebar-wrapper -->

      <!-- Page Content -->
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <div class="result-list-container">
            <!--
			<div class="filter-controls">
				<button class="toggle" @click="switchContainer">
					{{ showBooks ? 'Show Filters' : 'Hide Filters' }}
				</button>
				<SelectedFilters class="myfilters" showClearAll={true} clearAllLabel="Clear filters"/>
			</div>
            -->
            <reactive-list
              componentId="SearchResult"
              data-field="original_title.keyword"
              class="result-list"
              paginationAt="both"
              :pagination="true"
              :pages="10"
              :size="3"
              :class="{ full: showBooks }"
              :infiniteScroll="false"
              :innerClass="{pagination:'mypagi'}"
              :react="{ and: ['Orderable','SearchText','Filters', 'PublishedYear', 'Authors', 'Subjects'] }"
            >
              <book-display-panel
                slot="renderItem"
                class="renderItem"
                slot-scope="{ item }"
                v-bind="item"
              />
            </reactive-list>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
    </div>
    <!-- /#wrapper -->
  </reactive-base>
</template>

<style>
.mypagi {
  text-align: left;
}

.XXXfilternoscroll ul {
  overflow-y: visible;
  max-height: none;
}

.filters-container {
  overflow-y: visible;
  max-height: none;
}

/* .v--modal-overlay {
  background: red;
} */

/* .v--modal-box{
	top:40%;
} */
</style>
<script>
import "./../styles.css";
import "./../styles2.css";
import BookDisplay from "./BookDisplayPanel";

export default {
  name: "app",
  data: function() {
    return {
      showBooks: false
    };
  },
  methods: {
    switchContainer: function() {
      return (this.showBooks = !this.showBooks);
    },
    orderBook: function() {
      alert(
        "Book order processing available after integration with user database",
        "Feature not fully implemented"
      );
    },
    show() {
      alert("gloop");
      this.$modal.show("hello-world");
    },
    hide() {
      this.hide();
    },

    show_dialog(theUrl, srcComponent) {
      var xPos = $("#myButton").offset().left;
      var yPos = $("#myButton").offset().top;

      this.$modal.show("dialog", {
        text:
          "You are leaving Janssen Medical Cloud to navigate to an  external website.  We invite you to read its Privacy Policy",
        buttons: [
          {
            title: "I AGREE",
            handler: () => {
              window.open(theUrl);
              dialog: false;
            }
          },
          {
            title: "CANCEL"
          }
        ],
        pivotX: 1,
        pivotY: 1,
        position: {
          x: xPos,
          y: yPos
        }
      });

      this.$refs.offramp.width = "1000px";
      console.log(this.$refs.offramp);
    }
  }
};
</script>